import { render, staticRenderFns } from "./liveMeal.vue?vue&type=template&id=636f8fba&scoped=true&"
import script from "./liveMeal.vue?vue&type=script&lang=js&"
export * from "./liveMeal.vue?vue&type=script&lang=js&"
import style0 from "./liveMeal.vue?vue&type=style&index=0&id=636f8fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f8fba",
  null
  
)

export default component.exports